export default {
      id: "circle__accelerate-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#circle__accelerate",
      toString: function () {
        return this.url;
      }
    }